import actionTypes from './actionTypes';

const requestCovidReports = (args) => ({
    type: actionTypes.REQUEST_COVID_REPORTS,
    payload: args,
});

const covidReportsResponse = (success, errors, response) => ({
    type: actionTypes.COVID_REPORTS_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

const requestCovidReportDateRange = (args) => ({
    type: actionTypes.REQUEST_COVID_REPORT_DATE_RANGE,
    payload: args,
});

const covidReportDateRangeResponse = (success, errors, response) => ({
    type: actionTypes.COVID_REPORT_DATE_RANGE_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

export default {
    requestCovidReports,
    covidReportsResponse,
    requestCovidReportDateRange,
    covidReportDateRangeResponse,
};
